import React, { useCallback, useEffect, useState } from 'react';
import Joyride, { STATUS } from 'react-joyride';
import { useDispatch } from 'react-redux';

import { ZINDEX } from '../../constants';
import { useGame } from '../../context/use-game';
import { closeDemo } from '../../redux/actions';
import Tooltip from './tooltip';

const getTourContentFromDocument = steps =>
  steps
    .map((str, index) => {
      const isbody = index === 0;
      const section = document.getElementById(`noscript-${str}`);
      const [title] = section.getElementsByTagName('h2');
      const [content] = section.getElementsByTagName('p');
      const next = {
        content: content.innerHTML,
        disableBeacon: isbody,
        placement: (isbody && 'center') || 'bottom',
        target: (isbody && 'body') || `#demo-step-${str}`,
        title: title.innerHTML,
      };
      return next;
    })
    .filter(Boolean);

const RideTourComponent = React.memo(() => {
  const { demo } = useGame();
  const dispatch = useDispatch();
  const [steps, setSteps] = useState([]);

  const rideCallbackHandler = useCallback(
    data => {
      const { status } = data;
      const isFinished = [STATUS.FINISHED, STATUS.SKIPPED].includes(status);
      if (isFinished) dispatch(closeDemo());
    },
    [dispatch]
  );

  useEffect(() => {
    if (!steps.length) {
      const [noscript] = document.getElementsByTagName('noscript');
      const node = document.createElement('div');
      node.innerHTML = noscript.innerHTML;
      document.body.appendChild(node);
      const elements = getTourContentFromDocument(demo);
      setSteps(elements);
    }
  }, [demo, steps]);

  return (
    <Joyride
      continuous
      disableScrolling
      showProgress
      showSkipButton
      callback={rideCallbackHandler}
      disableCloseOnEsc={false}
      disableOverlayClose={false}
      floaterProps={{
        styles: {
          arrow: {
            display: 'inline-flex',
            length: 8,
            margin: 4,
            position: 'absolute',
            spread: 16,
          },
        },
      }}
      steps={steps}
      styles={{
        options: {
          arrowColor: '#272727',
          mixBlendColor: 'inherit !important',
          overlayColor: '#002a5f',
          zIndex: ZINDEX.WELCOME_TOUR,
        },
      }}
      tooltipComponent={Tooltip}
    />
  );
});

RideTourComponent.displayName = 'RideTourComponent';

export default RideTourComponent;
